import {i18n, type Locale} from "@/i18n-config";

export function resolveLocalizedNotificationValue(
    value: Partial<Record<Locale, string>>,
    locale: Locale,
) {
    return value[locale] || value[i18n.defaultLocale] || "";
}

export function configuredNotificationLocales(
    ...values: Array<Partial<Record<Locale, string>> | undefined>
) {
    return i18n.locales.filter((locale) =>
        locale === i18n.defaultLocale
        || values.some((value) => value?.[locale] !== undefined)
    );
}
